module.exports = __webpack_public_path__ + "workspace/static/img/accessMgmtThree.3404237.png";